if (!customElements.get('collection-load-more')) {
    customElements.define('collection-load-more', class CollectionLoadMore extends HTMLElement {
        constructor(){
            super();
            this.button = this.querySelector('a');
            this.button.addEventListener('click', this.handleButtonClick.bind(this));

            this.collectionSlider = this.closest('featured-collection-slider');
            // console.log(this.collectionSlider)
        }
        handleButtonClick(e){
            e.preventDefault();
            if (this.button.classList.contains('loading')) return;

            let url = this.button.href;
            this.button.classList.add('loading');
            this.button.querySelector('.loading-overlay__spinner').classList.remove('hidden');

            fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                const parsedResponse = new DOMParser().parseFromString(html, 'text/html')
                const productGrid = parsedResponse.getElementById('product-grid');
                const ogProductGrid = document.getElementById('product-grid');
                let container = this.button.closest('.mobile-load-more');
                if(container != null){
                    container.remove();
                }
                ogProductGrid.innerHTML += productGrid.innerHTML;

                const ogLoadMoreButtons = document.querySelectorAll('collection-load-more a');
                const newLoadMoreSection = parsedResponse.querySelector('collection-load-more');
                if (newLoadMoreSection){
                    let newLoadMoreButton = newLoadMoreSection.querySelector('a');
                    ogLoadMoreButtons.forEach(button => button.href = newLoadMoreButton.href)
                    
                    this.button.classList.remove('loading');
                    this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');
                }
                else{
                    let container = this.button.closest('.mobile-load-more');
                    if(container != null){
                        container.remove();
                    }
                    else{
                        ogLoadMoreButtons.forEach(button => button.remove());
                    }
                }
                if(this.collectionSlider != null){
                    this.collectionSlider.setMaxIndex();
                    this.collectionSlider.checkDisabledButtons();
                }

            })
        }
    })

}